import { Mapper } from '../../../common/ddd/mapper.base';
import { IWorkingSessionsAnalyticsActivityEnum } from '../../../common/enum/working-sessions/working-sessions-analytics-activity.enum';
import { SelfFocusScoreEntity } from '../../../core/domain/entities/scores/self-focus-score.entity';

export interface ISelfFocusScorePersistenceResponse {
  [IWorkingSessionsAnalyticsActivityEnum.FocusPercentage]: string;
}

export class SelfFocusScoreMapper
  implements Omit<Mapper<SelfFocusScoreEntity, any>, 'toResponse'>
{
  toDomain(record: ISelfFocusScorePersistenceResponse): SelfFocusScoreEntity {
    return SelfFocusScoreMapper.toDomain(record);
  }

  static toDomain(
    record: ISelfFocusScorePersistenceResponse
  ): SelfFocusScoreEntity {
    const entity = SelfFocusScoreEntity.create({
      focusScore: Number(
        record[IWorkingSessionsAnalyticsActivityEnum.FocusPercentage]
      ),
    });
    return entity;
  }
}
